export const PRODUCTINVENTORYBRANCH_LOADING = "PRODUCTINVENTORYBRANCH_LOADING";
export const PRODUCTINVENTORYBRANCH_RESET = "PRODUCTINVENTORYBRANCH_RESET";
export const GET_PRODUCTINVENTORYBRANCH = "GET_PRODUCTINVENTORYBRANCH";
export const GET_PRODUCTINVENTORYBRANCH_SUCCESS = "GET_PRODUCTINVENTORYBRANCH_SUCCESS";
export const GET_PRODUCTINVENTORYBRANCH_FAIL = "GET_PRODUCTINVENTORYBRANCH_FAIL";
export const DELETE_PRODUCTINVENTORYBRANCH = "DELETE_PRODUCTINVENTORYBRANCH"
export const DELETE_PRODUCTINVENTORYBRANCH_SUCCESS = "DELETE_PRODUCTINVENTORYBRANCH_SUCCESS"
export const DELETE_PRODUCTINVENTORYBRANCH_FAIL = "DELETE_PRODUCTINVENTORYBRANCH_FAIL"
export const UPDATE_PRODUCTINVENTORYBRANCH = "UPDATE_PRODUCTINVENTORYBRANCH"
export const UPDATE_PRODUCTINVENTORYBRANCH_SUCCESS = "UPDATE_PRODUCTINVENTORYBRANCH_SUCCESS"
export const UPDATE_PRODUCTINVENTORYBRANCH_FAIL = "UPDATE_PRODUCTINVENTORYBRANCH_FAIL"
export const ADD_NEW_PRODUCTINVENTORYBRANCH = "ADD_NEW_PRODUCTINVENTORYBRANCH"
export const ADD_PRODUCTINVENTORYBRANCH_SUCCESS = "ADD_PRODUCTINVENTORYBRANCH_SUCCESS"
export const ADD_PRODUCTINVENTORYBRANCH_FAIL = "ADD_PRODUCTINVENTORYBRANCH_FAIL"